var exports = {
  "M": "x234b8571--9aa604--input__wrapper",
  "j": "x234b8571--9aa604--input__wrapper--m",
};

module.exports = exports;
